import type { CargoPlanningStatusDto } from "../../../dto/Applications/CargoPlanningDto";
import type { CargoPlanningSyncState } from "../../../dto/Applications/CargoPlanningDto";
import type { AttachDocumentFormModel } from "../../../viewModels/Documents/AttachDocumentModel";

export const getCargoPlanningDocumentIds = (documents: AttachDocumentFormModel[] = []) =>
  documents
    .flatMap((document) => (document.status === "done" && document.response?.id ? [document.response.id] : []))
    .sort((a, b) => a - b);

export const areCargoPlanningDocumentsEqual = (first: number[], second: number[]) =>
  first.length === second.length && first.every((id, index) => id === second[index]);

export const getCargoPlanningMetadataKey = (dealId: number | null, syncState: CargoPlanningSyncState, documentIds: number[]) =>
  `${dealId ?? ""}:${syncState}:${documentIds.join(",")}`;

export const isCargoPlanningWaiting = (status: CargoPlanningStatusDto) =>
  status.syncState === "SYNCING" || status.documents.some((document) => document.status === "queued" || document.status === "processing");

export const canOpenCargoPlanning = (status: CargoPlanningStatusDto) =>
  Boolean(status.dealId) &&
  status.syncState !== "SYNCING" &&
  status.syncState !== "NOT_STARTED" &&
  status.documents.every((document) => document.uploadError || document.status === "ready" || document.status === "error");
